import { api } from '@/axios/instance/api';
import { type CreateTicketPayload } from '@/help/types';

export const createTicket = async (payload: CreateTicketPayload) => {
  return await api.post<void>(`/users/ticket`, payload);
};
